export default () => {
  const toggleElements = document.querySelectorAll('.js-toggle');
  if (toggleElements.length) {
    return import(/* webpackChunkName: "toggle" */ '../components/toggle')
      .then(({ default: Toggle }) => new Toggle(toggleElements))
      .catch((error) => `Toggle : ${error}`);
  }
  return null;
};
